import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../registration.service';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import { SainikSchemeApplicationModel,SainikSchemeApplicationStatusHistoryModel } from './../../shared/user.model';
import swal from "sweetalert2";

@Component({
  selector: 'app-application-history',
  templateUrl: './application-history.component.html',
  styleUrls: ['./application-history.component.css']
})
export class ApplicationHistoryComponent implements OnInit {
  formSubmitted: boolean;
  RoleName: string;
  sainikSchemeApplicationModel: any={};
  sainikSchemeApplicationStatusHistoryModel : any={};
  sainikSchemeApplicationStatusHistoryModels: any={};
  mode: string;
  applicationId:number;
  title:string;
  offices:any ={};
  users:any={};
  statuss:any={};

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {
    
  }

  ngOnInit() {
    this.RoleName=localStorage.getItem('userRole');
    this.route.params.subscribe(params => {      
      this.mode = params['mode'];
      this.applicationId = params['applicationId'];      
    });
    if (this.mode=='view')
    {
      this.title = "View Application Status";
    }
    else if (this.mode=='edit')
    {
      this.title = "Edit Application Status";
      this.GetOfficesApplicationBelongsTo();
      this.GetSainikApplicationStatus();
    }
    else
    {
      this.title = "Application Status";
    }
    this.GetApplicationDetails(this.applicationId);
    this.GetApplicationStatusHistoryDetails(this.applicationId);
  }
  GetSainikApplicationStatus()
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSainikApplicationStatus()
      .subscribe(
        (data) => {
          this.statuss = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetOfficesApplicationBelongsTo()
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getOfficesApplicationBelongsTo()
      .subscribe(
        (data) => {
          this.offices = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetApplicationDetails(applicationId)
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSchemeApplicationDetailsById(this.applicationId)
      .subscribe(
        (data) => {
          this.sainikSchemeApplicationModel = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  GetApplicationStatusHistoryDetails(applicationId)
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSchemeApplicationHistoryById(this.applicationId)
      .subscribe(
        (data) => {
          this.sainikSchemeApplicationStatusHistoryModels = data;
          //swal("warning",this.sainikSchemeApplicationModel.ID);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
      });
  }
  onOfficeChange(officeId) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllUsersForOffice(officeId)
    .subscribe(
    (data) => {
      this.users=data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });
  } 
  update(form: NgForm)
  {

  }
  onSubmit(form: NgForm) {
    if (!form.invalid) 
    {              
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationStatusHistoryModel.ApplicationId = this.applicationId;
      this.userService.updateAppliationStatus(this.sainikSchemeApplicationStatusHistoryModel).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Status Updated Successfully!','success');
        this.router.navigate(['/home/SchemesApprovals']);          
        }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
      this.formSubmitted = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/schemes/application-history/application-history.component.ts